var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import log from '../whisper';
export default function fetchAndSetCif(session, onComplete) {
    return __awaiter(this, void 0, void 0, function* () {
        // With Transmit v2 the CIF is returned with the session data from transmit
        // so we do not need to make a separate call to oldWeb to get the users CIF
        const bvid = `${session.cif || null},${session.guid || null}`;
        log.info({
            message: `Setting cookie: bvid=${bvid};domain=.ally.com;`,
        });
        document.cookie = `bvid=${bvid};domain=.ally.com;`;
        log.info({ message: 'Navigating to storefront...' });
        onComplete();
    });
}
//# sourceMappingURL=fetchAndSetCif.js.map